import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import NetActions from '../../Data/Redux/NetRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

class Net extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getNet } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'enrollments/net')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'enrollments/net')
      }
    } else {
      getNet()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { net, user, centers, centersInfo } = nextProps
    const newData = []
    if (net) {
      Object.keys(net).map((date) => {
        const day = { day: date, formatDay: moment(date).format('MMM DD') }
        day.Altas = net[date].total_enrollments
        day.Bajas = net[date].total_disenrollments
        newData.push(day)
      })
      this.setState({ data: newData })
    }
    if (centersInfo) {
      Object.keys(centersInfo).map((date) => {
        const day = { day: date, formatDay: moment(date).format('MMM DD') }
        day.Altas = centersInfo[date].total_enrollments
        day.Bajas = centersInfo[date].total_disenrollments
        newData.push(day)
      })
      this.setState({ data: newData })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('enrollments/net', this.props.activeCenter)
    } else {
      this.props.getNetExcel()
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Altas y Bajas"
        date={data[0] &&
          { initial: data[0].day, end: data[data.length - 1].day }}
        onClick={this.download}
        loading={!(data[0] !== undefined)}
      >
        {data[0] !== undefined &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="hour" />
            <YAxis />
            <Tooltip />
            <Legend content={<CustomizedLegend />} />
            <Bar dataKey="Altas" stackId="a" fill="#bb4ab7" />
            <Bar dataKey="Bajas" stackId="a" fill="#2A517F" />
          </BarChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ net, centerOptions, auth, centersInfo }) => ({
  net: net.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  centersInfo: centersInfo.net.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getNet: () => dispatch(NetActions.getRequest({}, true)),
  getNetExcel: () => dispatch(NetActions.NetExcelRequest({}, true)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Net))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Net.jsx